module.exports = "http://cdn.realive.com.ua/src/views/player/hudevo/phonenew/components/map/map.jpg";